import type { FeatureModule } from "@theg1group/feature-kit";
import { lazy } from "react";

export const feature: FeatureModule = {
	id: "games",
	nav: [
		{
			label: "Games",
			icon: "Gamepad2",
			path: "/games",
			group: "Content",
			order: 7,
			actions: ["view", "create", "edit", "delete"],
			// /games + /games/providers = BQ scrape (read); /games/catalog/* =
			// the curated catalog CRUD + logo upload. "/games/*" covers both.
			apiPaths: ["/games", "/games/*"],
		},
	],
	routes: [
		{
			path: "/games",
			component: lazy(() => import("./pages/Games.js").then((m) => ({ default: m.Games }))),
		},
		{
			path: "/games/:id",
			component: lazy(() =>
				import("./pages/GameDetail.js").then((m) => ({ default: m.GameDetail })),
			),
		},
	],
};
